import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: '[app-org-subordinates]',
  templateUrl: './org-subordinates.component.html',
  styleUrls: ['./org-subordinates.component.scss'],
})
export class OrgSubordinatesComponent implements OnInit{
  
  @Input({required: true}) employee: any;
  @Input({required: true}) selectDepartment: any;
  @Input({required: true}) showOnlyVacant!: boolean;
  
  constructor() { }
  
  ngOnInit() { }
    
  getInitials(name: string): string {
    if (!name) return '';
    const nameParts = name.trim().split(' ');
    const initials = nameParts.length > 1 ? nameParts[0][0] + nameParts[nameParts.length - 1][0] : nameParts[0][0];
    return initials.toUpperCase();
  }
  
  toggleChildren(employee: any) {
    employee.showChildren = !employee.showChildren;
  }
  
  toNumber(value: any): number {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }
  
}
